export const useEnv = () => {
  return import.meta.env;
};
